import { Switch } from "@design-system/shadcn";
import React, { useCallback, useMemo } from "react";

import { useFieldContext } from "../core/form-contexts";

type FormFieldSwitchProps = Omit<
  React.ComponentProps<typeof Switch>,
  "name" | "checked" | "onCheckedChange"
>;

function FormFieldSwitch(props: FormFieldSwitchProps) {
  const field = useFieldContext<boolean>();

  if (!field) {
    throw new Error("FormFieldSwitch must be used within form.AppField");
  }

  const hasError = useMemo(
    () => field.state.meta.errors.length > 0,
    [field.state.meta.errors.length]
  );

  const changeHandler = useCallback(
    (value: boolean) => field.handleChange(value),
    [field]
  );

  return (
    <Switch
      name={field.name}
      aria-invalid={hasError}
      checked={field.state.value}
      onCheckedChange={changeHandler}
      {...props}
    />
  );
}

export { FormFieldSwitch };
export type { FormFieldSwitchProps };
